import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import CompatibilityDropdownItem from '../item';

class Component extends BaseComponent {
    componentWillMount() {
        this.setState({
            showPathDropdown: false,
            showHashDropdown: false,
        });

        this.props.set({
            type: 'zodiac',
            slant: this.props.slant,
            base_url: '/astrology/compatibility/' + this.props.slant + '/',
        });
    }

    render({ slant, path, hash }) {
        return (
            <compatibility-chooser-zodiac slant={slant}>
                <div
                  class={`compatibility-chooser${path ? '' : ' chosen'}`}
                  name='path'
                  onMouseLeave={() => this.showDropdown('path', false)}
                  onMouseOver={() => this.showDropdown('path', true)}
                >
                    <h2 value={path ? path.name : null}>
                        {this.renderH2Text(path, 1)}
                    </h2>
                    <div
                      class='compatibility-chooser-dropdown'
                      style={`display: ${this.state.showPathDropdown ? 'block' : 'none'}`}
                    >
                        {this.props.signs.map(sign => this.renderItem(sign, 'path'))}
                    </div>
                </div>
                <div
                  class='compatibility-chooser'
                  name='hash'
                  onMouseLeave={() => this.showDropdown('hash', false)}
                  onMouseOver={() => this.showDropdown('hash', true)}
                >
                    <h2 value={hash ? hash.name : null}>
                        {this.renderH2Text(hash, 2)}
                    </h2>
                    <div
                      class='compatibility-chooser-dropdown'
                      style={`display: ${this.state.showHashDropdown ? 'block' : 'none'}`}
                    >
                        {this.props.signs.map(sign => this.renderItem(sign, 'hash'))}
                    </div>
                </div>
            </compatibility-chooser-zodiac>
        );
    }

    renderH2Text = (sign, num) => {
        if (sign) {
            return this.renderItemText(sign);
        }

        return (
            <span>Choose Sign {num}</span>
        );
    }

    renderItem = (sign, which) => {
        return (
            <CompatibilityDropdownItem
              value={sign.name}
              action={() => this.setSign(sign, which)}
              content={() => this.renderItemText(sign)}
            />
        );
    }

    renderItemText = (sign) => {
        if (sign) {
            return [
                <span>{sign.name.charAt(0).toUpperCase() + sign.name.slice(1)}</span>,
                <small>{sign.start} - {sign.end}</small>,
            ];
        }

        return null;
    }

    setSign = (sign, which) => {
        const value = which == 'path' ? {path: sign} : {hash: sign};
        this.props.set(value);

        this.showDropdown(which, false);
    }

    showDropdown = (which, show) => {
        if (which == 'path') {
            this.setState({
                showPathDropdown: show,
            });
        } else if (which == 'hash') {
            this.setState({
                showHashDropdown: show,
            });
        }
    }
}

const mapStateToProps = (state) => ({
    path: state['compatibility-chooser'] && state['compatibility-chooser'].path,
    hash: state['compatibility-chooser'] && state['compatibility-chooser'].hash,
    signs: state.zodiac && state.zodiac.signs,
});

const mapDispatchToProps = (dispatch) => ({
    set: (payload) => dispatch({ type: 'compatibility-chooser:set', payload: payload}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/compatibility/types/zodiac.js